import type { IGtmWebUser } from '@/types/IGtmWebUser'
import { defineStore } from 'pinia'

declare const window: Window & { dataLayer: Record<string, unknown>[]; };

export const useGoogleTagManagerStore = defineStore({
  id: "useGoogleTagManagerStore",
  state: () => ({
    rootUrl: '/api/Participation/',
    isAuthenticated: false,
    gtmData: null as IGtmWebUser | null,
    isLoadingGtmData: false
  }),
  getters: {
    authenticated: (state) => {
      return () => state.isAuthenticated;
    }
  },
  actions: {
    async getGTMDataLayer() {
      if(this.isLoadingGtmData) 
      {
        return;    
      }

      this.isLoadingGtmData = true;
      try {
        const url = `${this.$state.rootUrl}GetDataLayer`
        const response = await this.axiosFactory
            .withoutToken()
            .get<IGtmWebUser>(url);

        if (response.data) {
          this.gtmData = response.data;

          const plainData = JSON.parse(JSON.stringify(this.gtmData));

          if (!window.dataLayer) {
              window.dataLayer = [];
          }

          if (window.dataLayer.find(entry => entry.userId === plainData.userId)) {
            return plainData;
          }

          window.dataLayer.push(plainData);
          return plainData;
        } else {
          console.log('GTM API Error: No data');
        }
      } catch (error: any) {
        console.error('Failed to load GTM data:', error?.response.data ?? error);
      } finally {
        this.isLoadingGtmData = false;
      }
    }
  }
})